/** The first row as the item it will be saved as, slot by slot; follows every change to the mapping. */

import { SectionLabel } from "@/components/ui/box";
import { JsonView } from "@/components/ui/json-view";
import { SLOTS } from "../csv-mapping";
import type { DatasetItemInput } from "../types";
import { TARGET_LABEL } from "./targets";

export function ItemPreview({ item }: { item: DatasetItemInput | null }) {
  return (
    <section className="box flex flex-col" aria-label="First item">
      <div className="flex items-baseline justify-between gap-2 border-b border-line-soft px-4 py-3">
        <h3 className="text-sm font-semibold">First item</h3>
        <span className="text-xs text-muted">Row 2 of the file, as it will be saved</span>
      </div>
      {!item ? (
        <p className="px-4 py-3 text-xs text-muted">The file has no rows.</p>
      ) : (
        <div className="grid gap-4 p-4 sm:grid-cols-2">
          {SLOTS.map((slot) => {
            const value: unknown = slot === "input" ? item.input : item[slot];
            const empty = value === undefined || value === null;
            return (
              <div key={slot} className="flex min-w-0 flex-col gap-1.5">
                <SectionLabel>
                  {TARGET_LABEL[slot]} <span className="font-mono normal-case">· {slot}</span>
                </SectionLabel>
                {empty ? (
                  <span className="text-xs text-faint italic">Left out</span>
                ) : (
                  <div className="max-h-[220px] overflow-auto rounded-lg border border-line-soft bg-well px-3 py-2">
                    <JsonView value={value} label={`First item ${slot}`} toolbar={false} openDepth={3} />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}
